/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_SpeakersInputs */



/**
* | output |
* | --- |
* | "Project Speakers" |
*
* @param {Project_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_speakers = /** @type {((inputs?: Project_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intervenants du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektsprecher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Relatori del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Спикеры проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ponentes del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目发言人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトスピーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना वक्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palestrantes do Projeto")
	return /** @type {LocalizedString} */ ("Project Speakers")
});